import { Navigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function ParticipantGroupRedirect() {
  const [groupId, setGroupId] = useState(null);
  const [done, setDone] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/groups");
        if (data.length > 0) setGroupId(data[0].id);
      } catch {
        // ignore
      } finally {
        setDone(true);
      }
    })();
  }, []);
  if (!done) return <div className="p-10 text-center text-[#94A3B8]">Lade…</div>;
  if (groupId) return <Navigate to={`/admin/groups/${groupId}`} replace />;
  return <Navigate to="/dashboard/participant" replace />;
}
